import React, { Component } from "react";
import { MDBContainer, MDBRow, MDBCol, MDBIcon, MDBTooltip } from "mdb-react-ui-kit";
import "./WorkActivity.scss";
import BasicTextArea from '../SharedComponents/BasicTextArea/BasicTextArea';
import { withUserContext } from "../../../contexts/UserContext";
import BasicButton from '../SharedComponents/BasicButton/BasicButton';

class EditNotesModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            notesText:this.props?.notesText
        };
    }
    onNotesChange = (newText) => {
        this.setState({
            notesText:newText
        })
    }
    componentWillUnmount = () => {
        this.props?.onNotesSave(this.state?.notesText)
    }
    render() {
        return (
            <div className="editNotesContainer" style={{padding: "15px"}}>
                <BasicTextArea
                    tabIndex={0}
                    id="textArea"
                    value={this.state?.notesText}
                    label={''}
                    rows="12"
                    onChange={(e) => this.onNotesChange(e.target.value)}
                />
            </div>
        );
    }
}
export default withUserContext(EditNotesModal);